import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import GridComponent from '../../../../component/grid/GridComponent.component';
import ButtonBackComponent from "../../../../component/buttton/ButtonBack.component";
import { Title } from "../../../../component/title/Title";
import { useManagement } from '../../../../context/Management';
import { Container } from '../../../scheduleMaintenance/styles';
import { getPainelChamada } from './StandbyPanel.service';
import { TablePanelInterface } from './interface/InterfaceStandbyPanel';
import { useSnackbar } from '../../../../context/Snackbar';

const StandbyPanel = () => {

  const { valueCd } = useManagement();
  const [date, setDate] = useState('');
  const [tablePanel, setTablePanel] = useState<TablePanelInterface[]>([]);
  const [tableAux, setTableAux] = useState<TablePanelInterface | undefined>(undefined);
  const [history, setHistory] = useState<TablePanelInterface[]>([])
  const [reload, setReload] = useState(0)

  const { setSnackbar } = useSnackbar();

  const currentDate = useCallback(() => {
    const dateOriginal = new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).replace(' ', ' - ');
    setDate(dateOriginal);
  }, [date]);

  const initialState = () => {
    setTableAux(undefined);
    setHistory([]);
    setTablePanel([])
  }

  useEffect(() => {
    currentDate();
    let dateHour = setTimeout(() => {
      currentDate()
    }, 60000);
    return () => {
      clearTimeout(dateHour);
    };
  }, [currentDate]);

  const getAllDriversPanel = async () => {
    if(!valueCd) {
      setSnackbar({msg: 'Nenhum CD selecionado.', subMsg: 'Por favor selecione um CD.', type: 'error'});
    } else {
      initialState();
      const res = await getPainelChamada(`${valueCd}`);
      const table = res.data.filter((item: TablePanelInterface) => {
        const data = {
          placa: item.PLACA,
          situacao: item.SITUACAO,
          cd: item.cd,
          doca: item.doca,
          statusVeiculo: item.statusVeiculo
        }
        return data.situacao === "CARREGANDO";
      })

      setTablePanel(table);
    }
  }
  useEffect(() => {
    getAllDriversPanel();
  }, []);

  useEffect(() => {
    let timer = setTimeout(() => {

      getAllDriversPanel();
      setReload(reload + 1);
    }, 1000*90);

    return () => {
      clearTimeout(timer);
    };
  }, [reload]); // eslint-disable-line

  useEffect(() => {
    const tableLength = tablePanel.length;
    const historyLength = history.length+1;

    if(historyLength <= tableLength) {
      setTimeout(() => {
        if(tableAux !== undefined) {
          const auxHistory = [...history];

          auxHistory.unshift(tablePanel[historyLength-1])
          setHistory(auxHistory)
        }
        setTableAux(tablePanel[historyLength-1])

      }, 5000)
    }
  }, [tableAux, tablePanel, history])

  return (
    <>
      <ButtonBackComponent to="/gestao-de-patio" />

      <Grid item xs={12} sm={12} md={12} >
        <GridComponent justify="space-between" alignItems="flex-end">
          <Title fontSize={35} fontWeigth='900' >Monitor de Espera</Title>
          <Title fontSize={35} fontWeigth='900' >{date} </Title>
          <Title fontSize={35} fontWeigth='900'>CD - {valueCd}</Title>
        </GridComponent>
        <Grid item xs={12} sm={12} md={12}>
          <GridComponent justify="space-between">
            <Title fontSize={35}>Veiculo Placa: {tableAux?.PLACA} <br />
              Seguir Para Doca: {tableAux?.doca}
            </Title>
            <Container >
              <span className="title">Histórico</span>
              {history.map((item, index) => (
                <div key={index}>
                  <span>{`Placa ${item?.PLACA}`}</span>
                  <span>{`Doca ${item?.doca}`}</span>
                </div>
              ))}
            </Container>
          </GridComponent>

        </Grid>
      </Grid>
    </>
  )
}

export default StandbyPanel
